'use client'

import { noop } from 'lodash'
import { createContext } from 'react'

import { UiState } from '@marketplace-web/shared/ui-state-util'
import {
  DropOffPointCarrierModel,
  DropOffPointModel,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'

import { FetchNearbyDropOffPointsArgs } from './types'

export type DropOffPointMapContextType = {
  fetchNearbyDropOffPoints(args: FetchNearbyDropOffPointsArgs): void
  clearNearbyDropOffPoints(): void
  selectDropOffPoint(point: DropOffPointModel | null | undefined): void
  nearbyDropOffPoints?: Array<DropOffPointModel>
  selectedDropOffPoint?: DropOffPointModel | null
  dropOffPointCarrier?: DropOffPointCarrierModel | null
  dropOffPointSource?: string | null
  uiState: UiState
}

const DropOffPointMapContext = createContext<DropOffPointMapContextType>({
  fetchNearbyDropOffPoints: noop,
  clearNearbyDropOffPoints: noop,
  selectDropOffPoint: noop,
  nearbyDropOffPoints: undefined,
  selectedDropOffPoint: undefined,
  dropOffPointCarrier: undefined,
  dropOffPointSource: undefined,
  uiState: UiState.Idle,
})

export default DropOffPointMapContext
